
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content-library",
      function () {
        return require("private-next-pages/content-library/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content-library"])
      });
    }
  